import { createContext } from "react";

export interface SuccessFactorsIntegration {
  report_url_type: string;
  team_id: string;
  company_id: string;
  api_user: string;
  success_factors_oauth_client_id: string;
  success_factors_oauth_token_endpoint: string;
  odata_base_url: string;
  x509_certificate: string;
  saml_private_key: string;
}

export const EMPTY_SUCCESSFACTORS_INTEGRATION: SuccessFactorsIntegration = {
  report_url_type: "CLIENT_PORTAL_URL",
  team_id: "",
  company_id: "",
  api_user: "",
  success_factors_oauth_client_id: "",
  success_factors_oauth_token_endpoint: "",
  odata_base_url: "",
  x509_certificate: "",
  saml_private_key: "",
};

export interface SuccessFactorsIntegrationContextType {
  integrationData: SuccessFactorsIntegration;
  setIntegration: (data: SuccessFactorsIntegration) => void;
}

export const SuccessFactorsIntegrationContext =
  createContext<SuccessFactorsIntegrationContextType>({
    integrationData: EMPTY_SUCCESSFACTORS_INTEGRATION,
    setIntegration: () => {},
  });
